export interface WmsLayerInfo {
  name: string;
  title: string;
  crs: string[];
}

export interface WmsCapabilities {
  version: string;
  getMapUrl: string;
  layers: WmsLayerInfo[];
  serviceTitle: string;
}

const XLINK = "http://www.w3.org/1999/xlink";

export function parseWmsCapabilities(xml: string): WmsCapabilities {
  const doc = new DOMParser().parseFromString(xml, "application/xml");
  if (doc.querySelector("parsererror")) throw new Error("invalidWms");
  const root = doc.documentElement;
  if (root.localName !== "WMS_Capabilities" && root.localName !== "WMT_MS_Capabilities") {
    throw new Error("invalidWms");
  }
  const version = root.getAttribute("version") ?? "1.3.0";
  const serviceTitle =
    doc.querySelector("Service > Title")?.textContent?.trim() || "WMS";
  const getMapHref =
    doc
      .querySelector("Capability Request GetMap DCPType HTTP Get OnlineResource")
      ?.getAttributeNS(XLINK, "href") ??
    doc.querySelector("Service > OnlineResource")?.getAttributeNS(XLINK, "href");
  if (!getMapHref) throw new Error("invalidWms");

  const layers: WmsLayerInfo[] = Array.from(doc.querySelectorAll("Layer"))
    .filter((l) => l.querySelector(":scope > Name"))
    .map((l) => {
      const nameEl = l.querySelector(":scope > Name");
      const titleEl = l.querySelector(":scope > Title");
      const name = (nameEl?.textContent ?? "").trim();
      const title = (titleEl?.textContent ?? "").trim() || name;
      const crs = Array.from(l.querySelectorAll(":scope > CRS, :scope > SRS"))
        .map((n) => (n.textContent ?? "").trim())
        .filter(Boolean);
      return { name, title, crs };
    });
  if (layers.length === 0) throw new Error("invalidWms");
  return { version, getMapUrl: getMapHref, layers, serviceTitle };
}

export function buildWmsTileUrl(caps: WmsCapabilities, layerName: string): string {
  const sep = caps.getMapUrl.includes("?") ? "&" : "?";
  const isV13 = caps.version.startsWith("1.3");
  const srsParam = isV13 ? "crs" : "srs";
  const names = layerName.split(",").map((s) => s.trim()).filter(Boolean);
  const layersValue = names.map((n) => encodeURIComponent(n)).join(",");
  const stylesValue = names.map(() => "").join(",");
  const params = [
    "service=WMS",
    `version=${caps.version}`,
    "request=GetMap",
    `layers=${layersValue}`,
    `styles=${stylesValue}`,
    "format=image/png",
    "transparent=true",
    "width=256",
    "height=256",
    `${srsParam}=EPSG:3857`,
    "bbox={bbox-epsg-3857}",
  ].join("&");
  return `${caps.getMapUrl}${sep}${params}`;
}
